import React from "react";

export default function Footer() {
  return (
    <div className="sociial-media">
      <a href="https://www.facebook.com/arun.shukla.1865904/" target="_blank">
        <i className="fab fa-facebook"></i>
      </a>
      <a href="https://twitter.com/ArunShu47012704" target="_blank">
        <i className="fab fa-twitter"></i>
      </a>
      <a
        href="https://wa.me/+916239419039/?text=Hi, I am Arun.. Let's Chat"
        target="_blank"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
      <a href="https://www.instagram.com/annshu_07/" target="_blank">
        <i className="fab fa-instagram"></i>
      </a>
    </div>
  );
}
